import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./TSD.css";
import "../ReportManagement/ReportManagement.css";
import FileExport from "./../../Assets/Images/CommanImages/fileexport.png";
import Filter from "./../../Assets/Images/CommanImages/filter.png";
import columnaddition from "./../../Assets/Images/CommanImages/rectangleplus.png";
import updown from "./../../Assets/Images/CommanImages/updown.png";
import searchicon from "./../../Assets/Images/CommanImages/searchyellow.png";
import leftArrow from "./../../Assets/Images/CommanImages/Larrowbar.png"; // Correct import path
import rightArrow from "./../../Assets/Images/CommanImages/Rarrowbar.png"; // Correct import path

import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "../ReportManagement/TableComponent.css";
import { API_BASE_URL } from "../../Config/Config";

// import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import TableComponent from "./TableComponent";
const TableComponent = ({
  headers,
  data,
  searchPlaceholder,
  dataClient,
  setPagePath,
}) => {
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [averageRunTime, setAverageRunTime] = useState("");
  const [filterRunTime, setFilterRunTime] = useState("");

  // console.log("TableComponent",dataClient)

  useEffect(() => {
    setVisibleColumns(headers.slice(0, 4)); // Initialize with the first four columns visible
  }, [headers]);

  const handleColumnSelection = (column) => {
    if (visibleColumns.includes(column)) {
      setVisibleColumns(visibleColumns.filter((col) => col !== column));
    } else {
      setVisibleColumns([...visibleColumns, column]);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to the first page on search
  };

  const handleFilterRunTimeChange = (e) => {
    setFilterRunTime(e.target.value);
  };

  const handleApplyFilter = () => {
    setAverageRunTime(filterRunTime);
    setIsFilterVisible(false); // Close the modal
    setCurrentPage(1); // Reset to the first page on filter
  };

  const filteredData = data.filter((row) => {
    const matchesSearchQuery = row[0]
      .toLowerCase()
      .includes(searchQuery.toLowerCase());
    const matchesAverageRunTime =
      averageRunTime === "" || row[2] === averageRunTime;
    return matchesSearchQuery && matchesAverageRunTime;
  });

  const handleSort = (column) => {
    let direction = "asc";
    if (sortConfig.key === column && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: column, direction });
  };

  const sortedData = React.useMemo(() => {
    let sortableData = [...filteredData];
    if (sortConfig.key !== null) {
      const colIndex = headers.indexOf(sortConfig.key);
      sortableData.sort((a, b) => {
        if (a[colIndex] < b[colIndex]) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (a[colIndex] > b[colIndex]) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableData;
  }, [filteredData, sortConfig, headers]);

  const handleExport = (type) => {
    const exportData = sortedData.map((row) =>
      visibleColumns.map((column) => row[headers.indexOf(column)])
    );

    const fileName = prompt("Enter the file name:");

    if (!fileName) {
      return;
    }

    if (type === "excel" || type === "csv") {
      const worksheet = XLSX.utils.aoa_to_sheet([
        visibleColumns,
        ...exportData,
      ]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const fileExtension = type === "csv" ? "csv" : "xlsx";
      const mimeType =
        type === "csv"
          ? "text/csv"
          : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

      const file = XLSX.write(workbook, {
        bookType: fileExtension,
        type: "array",
      });
      const blob = new Blob([file], { type: mimeType });
      FileSaver.saveAs(blob, `${fileName}.${fileExtension}`);
    } else if (type === "pdf") {
      const doc = new jsPDF();
      doc.autoTable({
        head: [visibleColumns],
        body: exportData,
      });

      doc.save(`${fileName}.pdf`);
    }
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1); // Reset to the first page
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(sortedData.length / pageSize);
  const paginatedData = React.useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return sortedData.slice(startIndex, startIndex + pageSize);
  }, [sortedData, currentPage, pageSize]);

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <button
            key={i}
            onClick={() => handlePageChange(i)}
            style={{ borderRadius: "5px" }}
            className={i === currentPage ? "active" : ""}
          >
            {i}
          </button>
        );
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 3; i++) {
          pages.push(
            <button
              key={i}
              style={{ borderRadius: "5px" }}
              onClick={() => handlePageChange(i)}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {totalPages}
          </button>
        );
      } else if (currentPage > 3 && currentPage < totalPages - 2) {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            1
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots2">
            ...
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {totalPages}
          </button>
        );
      } else {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            1
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
      }
    }
    return pages;
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "1.5%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "82vw",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="text"
              placeholder={searchPlaceholder}
              name="search"
              className="input-top-tc"
              onChange={handleSearch}
            />
            <img src={searchicon} className="search-icon-tc" alt="search" />
          </div>
          <div style={{ textAlign: "end" }}>
            Displaying{" "}
            {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
            {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
            {sortedData.length} records |
            {["10", "25", "50", "100", "500"].map((size) => (
              <span
                key={size}
                onClick={() => handlePageSizeChange(Number(size))}
                style={{
                  cursor: "pointer",
                  margin: "0 5px",
                  textDecoration:
                    size === pageSize.toString() ? "none" : "underline",
                  color: size === pageSize.toString() ? "black" : "#337AB7",
                }}
              >
                {size}
              </span>
            ))}
          </div>
        </div>
      </div>
      <div
        className="row-tc"
        style={{
          backgroundColor: "#D6D6D6",
          marginTop: "9px",
          borderTop: "1px solid grey",
          borderBottom: "1px solid grey",
        }}
      >
        <div
          className="col-cs2-tc"
          style={{
            backgroundColor: "#FFBD20",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            paddingLeft: "8px",
          }}
          onClick={() => setIsFilterVisible(!isFilterVisible)}
        >
          <img
            src={Filter}
            style={{ height: "25px", width: "25px" }}
            alt="filter"
          />
          <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
        </div>
        <div
          className="col-tc"
          style={{
            textAlign: "end",
            marginRight: "8px",
            display: "flex",
            alignItems: "center",
            position: "relative",
            cursor: "pointer",
          }}
          onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
        >
          <img
            src={columnaddition}
            style={{ height: "25px", width: "25px" }}
            alt="column addition"
          />
          <span style={{ marginLeft: "10px", color: "#2F2E40" }}>
            Column Selection
          </span>
          {isColumnDivVisible && (
            <>
              <div className="arrow-up-tc"></div> {/* Add the arrow */}
              <div className="popupColumn-tc">
                {headers.map((column, index) => (
                  <div
                    key={index}
                    onClick={() => handleColumnSelection(column)}
                  >
                    <input
                      type="checkbox"
                      id={`column-${index}`}
                      name="columnSelection"
                      value={column}
                      className="square-checkbox-tc"
                      checked={visibleColumns.includes(column)}
                      readOnly
                    />
                    <label
                      htmlFor={`column-${index}`}
                      style={{ marginLeft: "10px" }}
                    >
                      {column}
                    </label>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>

      <table className="table-tc" style={{ width: "100%" }}>
        <thead>
          <tr>
            {visibleColumns.map((heading, index) => (
              <th
                className="Heading-tc"
                key={index}
                style={{ textAlign: "center", cursor: "pointer" }}
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "left",
                    justifyContent: "left",
                  }}
                >
                  {heading}
                  <img
                    onClick={() => handleSort(heading)}
                    src={updown}
                    style={{
                      height: "20px",
                      width: "20px",
                      marginLeft: "5px",
                    }}
                    alt="sort"
                  />
                </span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {paginatedData.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
            >
              {visibleColumns.map((column, cellIndex) => (
                <td
                  key={cellIndex}
                  style={{ textAlign: "left", color: "#6A6A6A" }}
                >
                  {headers.indexOf(column) === 0 ? (
                    <Link
                      style={{ color: "#337ab7" }}
                      // to={{
                      //   pathname: row[4],
                      //   // state: { dataClient: dataClient },
                      // }}
                      to={`${row[4]}?reportName=${encodeURIComponent(
                        row[headers.indexOf(column)]
                      )}`}
                      onClick={() => {
                        // console.log('Navigating to:', row[4], 'with displayName:', row[headers.indexOf(column)]);
                        setPagePath(
                          `Reports > Reports Dashboard > ${
                            row[headers.indexOf(column)]
                          }`
                        );
                      }}
                    >
                      {row[headers.indexOf(column)]}
                    </Link>
                  ) : (
                    row[headers.indexOf(column)]
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pagination-tc">
        <button
          onClick={() => handlePageChange(1)}
          disabled={currentPage === 1}
          className="extreme-left-tc-pagination"
        >
          <img src={leftArrow} alt="" />
        </button>
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="lefttc-pagination"
        >
          {"<"}
        </button>
        {renderPagination()}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="righttc-pagination"
        >
          {">"}
        </button>
        <button
          onClick={() => handlePageChange(totalPages)}
          disabled={currentPage === totalPages}
          className="extreme-right-tc-pagination"
        >
          <img src={rightArrow} alt="" />
        </button>
      </div>

      {isFilterVisible && (
        <div className="filter-sidebar-tc">
          <div className="filter-content-tc" style={{ position: "relative" }}>
            <button
              className="repman-cross-btn"
              style={{
                position: "absolute",
                left: "-29px",
                height: "40px",
                width: "30px",
                color: "white",
                border: "none",
                fontSize: "20px",
                fontWeight: "700",
                borderRadius: "5px 0px 0px 5px",
              }}
              onClick={() => {
                setIsFilterVisible(false);
              }}
            >
              <p>X</p>
            </button>
            <h3 className="AdvanceF-heading-tc"> Filter</h3>
            <div style={{ display: "flex", justifyContent: "end" }}>
              <button
                style={{
                  width: "30%",
                  height: "32px",
                  borderRadius: "5px",
                  border: "2px solid #2F2E40",
                  fontSize: "16px",
                  fontWeight: "700",
                  backgroundColor: "white",
                  marginRight: "8px",
                  marginTop: "10px",
                }}
                onClick={handleApplyFilter}
              >
                APPLY
              </button>
            </div>
            <input
              type="text"
              placeholder="Enter Average Run Time"
              value={filterRunTime}
              onChange={handleFilterRunTimeChange}
            />
          </div>
        </div>
      )}

      {isModalVisible && (
        <div className="modal-tc">
          <div className="modal-content-tc">
            <h3>Select Export File Type</h3>
            <button
              onClick={() => [handleExport("excel"), setIsModalVisible(false)]}
            >
              Excel
            </button>
            <button
              onClick={() => [handleExport("csv"), setIsModalVisible(false)]}
            >
              CSV
            </button>
            <button
              onClick={() => [handleExport("pdf"), setIsModalVisible(false)]}
            >
              PDF
            </button>
            <button onClick={() => setIsModalVisible(false)}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
};

// const TSD = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
//   setPagePath
// }) => {
//   const headers = ["Report Title", "Description", "Average Run Time"];
//   const [reportDashboardData, setReportDashboardData] = useState([]);

//   // console.log("ReportManagement",dataClient)

//   useEffect(() => {
//     fetch(
//       // `http://127.0.0.1:8000/coaching-collaborator-api/api/v1/reports-dashboard`
//       `${API_BASE_URL}/coaching-collaborator-api/api/v1/reports-dashboard`
//     )
//       .then((response) => response.json())
//       .then((data) => {
//         // console.log("repdash", data);
//         // Map the API data to the expected table data format
//         const transformedData = data.data.map((report) => [
//           report.display_name,
//           report.report_desc,
//           "", // Assuming Average Run Time is not provided in API data
//           report.ui_element,
//           report.ui_path,
//         ]);
//         setReportDashboardData(transformedData);
//       })
//       .catch((error) =>
//         console.error("Error fetching report_dashboard:", error)
//       );
//   }, []);

//   //  console.log(reportDashboardData);

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "20px",
//         marginBottom: "40px",
//       }}
//     >
//       <div
//         className=""
//         style={{ position: "sticky", top: "0", paddingLeft: "15px" }}
//       >
//         <div className="Header-up ">
//           <p style={{ color: "#2F2E40", fontSize: "30px" }}>
//             Test Series Dashboard
//           </p>
//         </div>

//         <p style={{ marginTop: "1%", color: "#2F2E40" }}>
//           View, create, or filter reports. View and manage the list of reports
//           already available or create a new report.
//         </p>

//         <div>
//           <TableComponent
//             headers={headers}
//             data={reportDashboardData}
//             searchPlaceholder="Search by Report Title..."
//             dataClient={dataClient}
//             setPagePath={setPagePath}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };
// export default TSD;

// const TSD = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
//   setPagePath,
// }) => {
//   const headers = ["Report Title", "Description", "Average Run Time"];
//   const [reportDashboardData, setReportDashboardData] = useState([]);

//   useEffect(() => {
//     // Replace fetching from API with static data
//     const transformedData = [
//       [
//         "New Test Series V2", // display_name
//         "New Test Series V2", // report_desc
//         "", // Assuming Average Run Time is not provided in API data
//         "NTSV2", // ui_element
//         "/ntsv2", // ui_path
//       ],
//     ];
//     setReportDashboardData(transformedData);
//   }, []);

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "20px",
//         marginBottom: "40px",
//       }}
//     >
//       <div
//         className=""
//         style={{ position: "sticky", top: "0", paddingLeft: "15px" }}
//       >
//         <div className="Header-up ">
//           <p style={{ color: "#2F2E40", fontSize: "30px" }}>
//             Test Series Dashboard
//           </p>

//           <button className="Create-Button-New">+&nbsp;CREATE</button>
//         </div>

//         <p style={{ marginTop: "1%", color: "#2F2E40" }}>
//           View, create, or filter series. View and manage the list of series
//           already available or create a new series.
//         </p>

//         <div>
//           <TableComponent
//             headers={headers}
//             data={reportDashboardData}
//             searchPlaceholder="Search by Report Title..."
//             dataClient={dataClient}
//             setPagePath={setPagePath}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TSD;




const TSD = ({ setMessageBox, setIsMessageBoxVisible, setActiveImg, dataClient }) => {
  const headers = ["Test Series Name", "Description", "Average Run Time"];
  const [reportDashboardData, setReportDashboardData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch data from the API
    fetch(
      "https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1/test-series-dashboard?client_id=1&client_branch_id=1",
      { headers: { accept: "application/json" } }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status_code === 200) {
          // Transform data to fit the table format
          const transformedData = data.data.map((series) => [
            series.ts_name, // Test Series Name
            series.ts_desc, // Description
            "", // Assuming Average Run Time is not provided in API data
            "NTSV2", // ui_element
            "/ntsv2", // ui_path
          ]);
          setReportDashboardData(transformedData);
        }
      })
      .catch((error) => console.error("Error fetching test series data:", error));
  }, []);

  return (
    <div style={{ height: "auto", width: "100%", paddingLeft: "20px", marginBottom: "40px" }}>
      <div className="" style={{ position: "sticky", top: "0", paddingLeft: "15px" }}>
        <div className="Header-up ">
          <p style={{ color: "#2F2E40", fontSize: "30px" }}>Test Series Dashboard</p>
          <button className="Create-Button-New" onClick={() => navigate("/ntsv2")}>+&nbsp;CREATE</button>
        </div>
        <p style={{ marginTop: "1%", color: "#2F2E40" }}>
          View, create, or filter series. View and manage the list of series already available or create a new series.
        </p>
        <div>
          <TableComponent
            headers={headers}
            data={reportDashboardData}
            searchPlaceholder="Search by Test Series Name..."
            dataClient={dataClient}
          />
        </div>
      </div>
    </div>
  );
};

export default TSD;
